// PostDetail.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const PostDetail2 = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    // Fetch a single post by ID from WordPress REST API
    axios.get(`https://notesbynani.com/wp-json/wp/v2/posts/?slug=${slug}`)
      .then(response => {
        //setPost(response.data);
        if (response.data.length > 0) {
          setPost(response.data[0]); // WordPress returns an array of posts
        }
      })
      .catch(error => {
        console.error('Error fetching post details:', error);
      });
  }, [slug]);

  if (!post) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <h1>{post.title.rendered}</h1>
      <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
    </div>
  );
};

export default PostDetail2;
